<template>
    <form class="mt-5" id="step2-form">
        <div class="text-center" v-if="isLoading" >
            <loader width="5rem"></loader>
        </div>
        <div v-else >
            <section id="eductionSection">
                <div class="text-center mt-1 mb-3">
                    <h2 class="row m-0">
                        <div class="col-lg-6 text-left">Opleidingen</div> 
                        <div class="col-lg-6 text-center mt-3 mt-lg-0">
                            <button type="button" class="btn btn-azure btn-lg btn-long-round ml-3" @click="addEducation">
                                <font-awesome-icon icon="plus"></font-awesome-icon> Toevoegen
                            </button>
                        </div>
                    </h2>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered" v-if="form.educations.length > 0">
                        <thead>
                            <tr>
                                <th>Opleiding *</th>
                                <th>Opleidingsinstituut *</th>
                                <th>Jaar van afronding *</th>
                                <th>Voltooid</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody :key="index" v-for="(edu, index) in form.educations">
                            <tr>
                                <td>
                                    <select v-model="edu.svpb" :class="['form-control', ($v.form.educations.$each[index.toString()].name.$dirty) ? 'is-valid' : '']">
                                        <option v-for="e in educationsArray" :key="e">{{e}}</option>
                                    </select>
                                    <input type="text" placeholder="Opleiding..." v-model="edu.name" v-if="edu.svpb == 'Anders...'" :class="['form-control', ($v.form.educations.$each[index.toString()].name.$dirty) ? ($v.form.educations.$each[index.toString()].name.$error) ?'is-invalid' : 'is-valid' : '']" />
                                    <div class="invalid-feedback">
                                        Verplicht veld.
                                    </div>
                                </td>
                                <td>
                                    <input type="text" class="form-control" v-model="edu.institute" :class="['form-control', ($v.form.educations.$each[index.toString()].institute.$dirty) ? ($v.form.educations.$each[index.toString()].institute.$error) ?'is-invalid' : 'is-valid' : '']" />
                                    <div class="invalid-feedback">
                                        Verplicht veld.
                                    </div>
                                </td>
                                <td>
                                    <input type="number" class="form-control" v-model="edu.year" :class="['form-control', ($v.form.educations.$each[index.toString()].year.$dirty) ? ($v.form.educations.$each[index.toString()].year.$error) ?'is-invalid' : 'is-valid' : '']" />
                                    <div class="invalid-feedback">
                                        Verplicht veld.
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" :id="'eduCheck' + index" v-model="edu.completed">
                                        <label class="custom-control-label" :for="'eduCheck' + index"></label>
                                    </div>
                                </td>
                                <td rowspan="2" class="verticalCenter">
                                    <button type="button" class="btn btn-danger" @click="removeEducation">Verwijderen</button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Kopie Diploma <sup class="red" title="verplicht">*</sup></span>
                                        </div>
                                        <div class="custom-file">
                                            <input type="file" :class="['custom-file-input form-control', ($v.form.educations.$each[index.toString()].document.$dirty) ? ($v.form.educations.$each[index.toString()].document.$error) ? 'is-invalid' : 'is-valid' : '']" id="documentFile" name="document"  @change="setUploadFile($event, edu)">
                                            <label class="custom-file-label" for="documentFile">{{edu.documentName}}</label>
                                        </div>
                                    </div>
                                    <small><strong>Verplicht!</strong> Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.</small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <hr>
            <section id="certificationSection">
                <div class="text-center mt-5 mb-3">
                    <h2 class="row m-0">
                        <div class="col-lg-6 text-left">Certificeringen</div> 
                        <div class="col-lg-6 text-center mt-3 mt-lg-0">
                            <button type="button" class="btn btn-azure btn-lg btn-long-round ml-3" @click="addCertification">
                                <font-awesome-icon icon="plus"></font-awesome-icon> Toevoegen
                            </button>
                        </div>
                    </h2>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered" v-if="form.certifications.length > 0">
                        <thead>
                            <tr>
                                <th>Opleiding</th>
                                <th>Certificeringsinstituut</th>
                                <th>(Verwacht) Jaar van afronding</th>
                                <th>Voltooid</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody :key="index" v-for="(edu, index) in form.certifications">
                            <tr>
                                <td>
                                    <select v-model="edu.svpb" :class="['form-control', ($v.form.certifications.$each[index.toString()].name.$dirty) ? 'is-valid' : '']">
                                        <option v-for="e in certificationsArray" :key="e">{{e}}</option>
                                    </select>
                                    <input type="text" placeholder="Opleiding..." v-model="edu.name" v-if="edu.svpb == 'Anders...'" :class="['form-control', ($v.form.certifications.$each[index.toString()].name.$dirty) ? ($v.form.certifications.$each[index.toString()].name.$error) ?'is-invalid' : 'is-valid' : '']" />
                                    <div class="invalid-feedback">
                                        Verplicht veld.
                                    </div>
                                </td>
                                <td>
                                    <input type="text" class="form-control" v-model="edu.institute" :class="['form-control', ($v.form.certifications.$each[index.toString()].institute.$dirty) ? ($v.form.certifications.$each[index.toString()].institute.$error) ?'is-invalid' : 'is-valid' : '']" />
                                    <div class="invalid-feedback">
                                        Verplicht veld.
                                    </div>
                                </td>
                                <td>
                                    <input type="number" class="form-control" v-model="edu.year" :class="['form-control', ($v.form.certifications.$each[index.toString()].year.$dirty) ? ($v.form.certifications.$each[index.toString()].year.$error) ?'is-invalid' : 'is-valid' : '']" />
                                    <div class="invalid-feedback">
                                        Verplicht veld.
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" :id="'certCheck' + index" v-model="edu.completed">
                                        <label class="custom-control-label" :for="'certCheck' + index"></label>
                                    </div>
                                </td>
                                <td rowspan="2" class="verticalCenter">
                                    <button type="button" class="btn btn-danger" @click="removeCertification">Verwijderen</button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Kopie Certificaat <sup class="red" title="verplicht">*</sup></span>
                                        </div>
                                        <div class="custom-file">
                                            <input type="file" :class="['custom-file-input form-control', ($v.form.certifications.$each[index.toString()].document.$dirty) ? ($v.form.certifications.$each[index.toString()].document.$error) ? 'is-invalid' : 'is-valid' : '']" id="documentFile" name="document"  @change="setUploadFile($event, edu)">
                                            <label class="custom-file-label" for="documentFile">{{edu.documentName}}</label>
                                        </div>
                                    </div>
                                    <small><strong>Verplicht!</strong> Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.</small>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import globalFunctions from '@/mixins/globalFunctions'
import wizardFunctions from '@/mixins/wizardFunctions'
import { required, minLength } from 'vuelidate/lib/validators'
import { education } from '@/models/models.js'
import Loader from '@/components/Loader'

const fileValidation = (value) => 
{
    if(value != null)
    {
        const ext = value.name.split(".")[value.name.split(".").length - 1];
        const extentions = ['doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg'];
        return value.size <= 4000000 && extentions.indexOf(ext) >= 0;
    }
    return true;
}

export default {
    name: 'ProfileWizardTwo',
    props: ['clickedNext', 'currentStep'],
    mixins: [validationMixin, globalFunctions,wizardFunctions],
        components: {
            'loader': Loader
        },
    data() {
        return {
            isLoading: false,
            form: {
                educations: [],
                certifications: [],
            },
            educationsArray: [
                "Beveiliger (SVPB)",
                "Coordinator Beveiliging (SVPB)",
                "HBO Security Management",
                "Anders..."
            ],
            certificationsArray: [
                "Beroepsgericht Engels (SVPB)",
                "Beveiliging in de zorg (SVPB)",
                "Cameratoezicht (SVPB)",
                "Centralist Alarmcentrale (BoCA + VoCA) (SVPB)",
                "Event Security (Officer + Supervisor) (SVPB)",
                "Ordebewaring publieke dienstverlening (SVPB)",
                "Particulier onderzoeker (SVPB)",
                "Personeelsplanner (SVPB)",
                "Proactief beveiligen (SVPB)",
                "Persoonsbeveiliging (SVPB)",
                "Winkelsurveillance en Retailbeveiliging (SVPB)",
                "Havenbeveiliger (SVPB)",
                "Verkeersregelaar",
                "Brandwacht",
                "BHV",
                "EHBO",
                "Basisveiligheid VCA",
                "Anders..."
            ]
        }
    },
    validations: {
        form: {
            educations: {
                $each: {
                    name: {
                        required,
                        minLength: minLength(2)
                    },
                    institute: {
                        required,
                        minLength: minLength(2)
                    },
                    year: {
                        required
                    },
                    document: {
                        required,
                        fileValidation
                    }
                }
            },
            certifications: {
                $each: {
                    name: {
                        required,
                        minLength: minLength(2)
                    },
                    institute: {
                        required,
                        minLength: minLength(2)
                    },
                    year: {
                        required
                    },
                    document: {
                        required,
                        fileValidation
                    }
                }
            }
        }
    },
    mounted() {
        this.getProfile().then(() => {
            this.isLoading = false;
            this.$v.form.$touch();
            if(!this.$v.$invalid) {
                this.$emit('can-continue', {value: true});
            } else {
                this.$emit('can-continue', {value: false});
            }
            this.init = true;
        });
    },
    methods: {
        addEducation() {
            this.form.educations.push(new education({ id: -this.form.educations.length + 1, svpb: "Beveiliger (SVPB)", name: "Beveiliger (SVPB)", year: new Date().getFullYear(), completed: false }));
            this.$v.form.$touch();
        },
        addCertification() {
            this.form.certifications.push(new education({ id: -this.form.certifications.length + 1, svpb: "Beroepsgericht Engels (SVPB)", name: "Beroepsgericht Engels (SVPB)", year: new Date().getFullYear(), completed: false }));
            this.$v.form.$touch();
        },
        removeEducation(edu) {
            this.form.educations.splice(this.form.educations.indexOf(edu), 1);
        },
        removeCertification(edu) {
            this.form.certifications.splice(this.form.certifications.indexOf(edu), 1);
        },
        getProfile() {
            this.isLoading = true;
            return this.$http.get('api/Profile/Professional/Wizard/3').then((res) => 
            {
                this.form.educations = res.data.educations.map((e) => { 
                    return new education({
                        id: e.id,
                        svpb: e.name,
                        name: e.name,
                        institute: e.institute,
                        document: this.b64ToFile(e.document.file, '', e.document.fileName),
                        documentName: (e.document.fileName) ? e.document.fileName : 'Kies een document...',
                        year: e.year,
                        completed: e.completed
                    })
                });

                this.form.certifications = res.data.certifications.map((e) => { 
                    return new education({
                        id: e.id,
                        svpb: (this.certificationsArray.indexOf(e.name) < 0) ? "Anders..." :e.name,
                        name: e.name,
                        institute: e.institute,
                        document: this.b64ToFile(e.document.file, '', e.document.fileName),
                        documentName: (e.document.fileName) ? e.document.fileName : 'Kies een document...',
                        year: e.year,
                        completed: e.completed
                    })
                });
            }).catch(() => {
                this.isLoading = false;
            })
        },
        setProfile() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;

                let formData = new FormData();
                for ( var key in this.form) {
                    formData.append(key, JSON.stringify(this.form[key]))
                    for(var idx in this.form[key])
                    {
                        for(var prop in this.form[key][idx])
                        {
                            if(prop == 'document')
                            {
                                formData.append(key + idx, this.form[key][idx][prop]);
                            }
                        }
                    }
                }
                
                return this.$http.post('api/Profile/Professional/Wizard/3', formData).then(() => {
                    this.isLoading = false;
                    return resolve();
                }).catch((res) => {
                    this.isLoading = false;
                    return reject(res);
                    //alert('Oops, de vorige stap is niet goed opgeslagen!')
                })
            });
        }
    },
    watch: {
        $v: {
            handler: function (val) {
                if(!val.$invalid) {
                    this.$emit('can-continue', {value: true});
                } else {
                    this.$emit('can-continue', {value: false});
                }
            },
            deep: true
        },
        'form.educations': {
            handler(val) {
                val.forEach((v) => {
                    if(v.svpb != 'Anders...')
                        return v.name = v.svpb;
                    //return v.name = null;
                });
            },
            deep: true
        },
        'form.certifications': {
            handler(val) {
                val.forEach((v) => {
                    if(v.svpb != 'Anders...')
                        return v.name = v.svpb;
                    //return v.name = null;
                });
            },
            deep: true
        },
        clickedNext(val) {
            if(val === true) {
                this.$v.form.$touch();
            }
        }
    },
}
</script>

<style scoped lang="scss">
label {
    display: inline-block !important;
}
label:not(.custom-control-label) {
    font-weight: bold;
}
/*
label.custom-file-label {
    display: inline-block !important
}*/
.verticalCenter {
    vertical-align: middle;
    text-align: center;
}
tbody tr:nth-of-type(odd) {
    border-top: 5px double;
}
tbody tr:nth-of-type(odd) td {
    padding-top: 2em;
}

.btn-long-round {
    border-radius: 5rem;

    @media screen and (min-width: 425px) {
        float: right
    };
}

</style>